import { render, staticRenderFns } from "./AccountsEditUser.vue?vue&type=template&id=71608fee&scoped=true"
import script from "./AccountsEditUser.vue?vue&type=script&lang=js"
export * from "./AccountsEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71608fee",
  null
  
)

export default component.exports